<template>
    <suspense>
        <slot />

        <template #fallback>
            <flex-container>
                <bar-skeleton :width="150" dark />
            </flex-container>
        </template>
    </suspense>
</template>
